import {CheckboxGroup} from '@smart/react-components';
import React, {useMemo} from 'react';
import {boolean} from 'yup';
import type {Maybe} from '../../graphql';
import {useSchemas} from '../hooks/user-schemas';
import Intercept from './easy-form/Intercept';
import Fields from './easy-form/fields';
import type {preValidationTransform} from './easy-form/types';

interface IProps {
  tag: string;
  options: string[];
  initial?: string[];
  min?: number;
  set?: boolean;
  label?: Maybe<string>;
  labels?: Maybe<string[]>;
}

const fieldSchema = boolean().oneOf([true, false]);

const MultiCheckbox = function ({
  tag,
  options,
  initial = [],
  min = 0,
  set = true,
  label,
  labels,
}: IProps) {
  const {multiOf} = useSchemas();

  const transform: preValidationTransform = (merge) => {
    return Object.entries(merge)
      .filter((pair) => pair[1])
      .map((pair) => pair[0]);
  };

  const schema = useMemo(() => multiOf(options, min), [options, min]);

  return (
    <Intercept
      set={set}
      tag={tag}
      block="messages"
      outputTransform={transform}
      schema={schema}
      required={min > 0}
      label={label}
    >
      <CheckboxGroup>
        {options.map((optionTag, index) => {
          return (
            <Fields.Checkbox
              name={tag}
              initial={initial.includes(optionTag)}
              tag={optionTag}
              key={optionTag}
              schema={fieldSchema}
              label={labels && labels[index]}
            />
          );
        })}
      </CheckboxGroup>
    </Intercept>
  );
};

export default MultiCheckbox;
